import { render, staticRenderFns } from "./ProdutoImport.vue?vue&type=template&id=068abd66"
import script from "./ProdutoImport.vue?vue&type=script&lang=js"
export * from "./ProdutoImport.vue?vue&type=script&lang=js"
import style0 from "./ProdutoImport.vue?vue&type=style&index=0&id=068abd66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports